import moment from 'moment';

export const TS_FORMAT = 'MMM-DD-YYYY HH:mm:ss ZZ';
export const FILE_NAME_TS_FORMAT = 'MMM-DD-YYYY_HH_mm_ss_ZZ';

const formatCellValue = (header, value) => {
  try {
    if (value === null) {
      return '';
    }

    const { type = null } = header;

    switch (type) {
      case 'timestamp': {
        return formatTimestamp(value);
      }
      case 'dimension': {
        return value.join('');
      }
      case 'comment': {
        return value.join(',');
      }
      case 'notApplicable': {
        return 'NA';
      }
      case 'multi-filter': {
        const { valueIdx } = header;
        return value[valueIdx];
      }
      case 'custom': {
        const { exportMeta } = header;
        return exportMeta.get(value);
      }
    }
  } catch (error) {
    // default to initial value
  }

  return value;
};

export const formatTimestamp = (ts) => {
  return moment(ts).format(TS_FORMAT);
};

export const formatFileName = (prefix = 'pulse_report_') => {
  const name = `${prefix}_${moment().format(FILE_NAME_TS_FORMAT)}`;
  return name.replaceAll(' ', '_');
};

export const formatCell = (header, value) => {
  const val = formatCellValue(header, value);
  if (typeof val === 'string') {
    return `"${val.replace(/"/g, '""')}"`;
  }
  return val;
};
